import { useTranslation } from "react-i18next";
import styles from "./ReceiptSent.module.scss";
import Grid from "../../config/Grid/Grid";
import Button from "../../components/Button/Button";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";
import { generateReceipt } from "@/helpers/generateReceipt";

function ReceiptSent() {
  const { t, i18n } = useTranslation();
  const { email } = useVenuesDataStore();

  return (
    <Grid>
      <div className={`start-1 col-4 ${styles.receiptSentWrapper}`}>
        <div className={styles.receiptSentHeader}>
          <p className={`body-bold-large ${styles.receiptSentHeaderTitle}`}>
            {t("receiptSent.title")}
          </p>
        </div>
        <p className={`title-medium ${styles.receiptSentTitle}`}>
          {t("receiptSent.header.title")}
        </p>
        <p className={`title-bold-medium ${styles.receiptSentEmail}`}>
          {email}
        </p>
        <Button
          onClick={() => generateReceipt(i18n.language)}
          label={t("receiptSent.downloadReceipt")}
          icon="icon-medium las la-download"
          iconLocation="right"
          variant="contained"
          color="primary"
          maxWidth
          mobile
        />
      </div>
    </Grid>
  );
}

export default ReceiptSent;
